module.exports = __webpack_public_path__ + "img/cookie.c431ced1.svg";